var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1875 4.52084L23.25 2.58334L21.3125 4.52084L19.375 2.58334L17.4375 4.52084L15.5 2.58334L13.5625 4.52084L11.625 2.58334L9.6875 4.52084L7.75 2.58334V20.6667H3.875V24.5417C3.875 26.6858 5.60583 28.4167 7.75 28.4167H23.25C25.3942 28.4167 27.125 26.6858 27.125 24.5417V2.58334L25.1875 4.52084ZM19.375 25.8333H7.75C7.03958 25.8333 6.45833 25.2521 6.45833 24.5417V23.25H19.375V25.8333ZM24.5417 24.5417C24.5417 25.2521 23.9604 25.8333 23.25 25.8333C22.5396 25.8333 21.9583 25.2521 21.9583 24.5417V20.6667H10.3333V6.45834H24.5417V24.5417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 9.04169H11.625V11.625H19.375V9.04169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 9.04169H20.6667V11.625H23.25V9.04169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 12.9167H11.625V15.5H19.375V12.9167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12.9167H20.6667V15.5H23.25V12.9167Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactura);
export default __webpack_public_path__ + "static/media/factura.afea72b200fa651a2281361712bfc3b1.svg";
export { ForwardRef as ReactComponent };